export function findParentIds(
  qbankLevelItems: {
    id: string;
    parentLevelItemId: string | null;
  }[],
  parentId: string | null,
  parentIds: string[] = [],
): string[] {
  if (parentId === null) {
    return parentIds;
  }
  const parent = qbankLevelItems.find((item) => item.id === parentId);
  if (parent) {
    return findParentIds(qbankLevelItems, parent.parentLevelItemId, [...parentIds, parent.id]);
  }
  return parentIds;
}
